import { render, staticRenderFns } from "./StepDivider.vue?vue&type=template&id=af2e6a16&"
import script from "./StepDivider.vue?vue&type=script&lang=ts&"
export * from "./StepDivider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports